export enum DATA_SOURCE {
  DMAESTROS = 'dmaestros-api',
  VDI = 'vdi-api',
  COMPRA = 'compra-api',
  PLM = 'plm-api',
  SOAP = 'soap-api',
  FINANCIERO = 'financiero-api',
  DISTRIBUIDOR = 'distribuidor-api',
  INVOLVES = 'involves-api',
  SUSTENTO = 'sustento-api',
  VENTAS = 'venta-api',
  TIENDA = 'tiendapp-api',
  BALANZA = 'balanza-api',
  RPLUS = 'rplus-api',
  SEGURIDAD = 'seguridad-api',
  NOMINA = 'nomina-api',
  VMI = 'vmi-api',
  IO_INDUSTRIAS = 'industria-io-api',
  LOGISTICA = 'logistica-api',
  CHATBOT = 'adam-api',
  ADAM = 'adam-api',
}

export const environment = {
  production: true,
  protocol: 'https',
  subDomain: "",
  domain: 'apiqas2-lf.lafabril.com.ec',
  port: "",
  gateway: 'qrk/app/ms',
  dataSource: 'dmaestros-api',
  apiVersion: 'v1',
  prefix: 'api',
  service: 'services',
};
